// extracted by mini-css-extract-plugin
module.exports = {"storyCard":"StoryCard_storyCard__NxFC9"};